<template>
  <el-row id="orgUserGroupChoice">
    <el-dialog v-model="dialogMultipleChoiceVisible" class="noPaddingDialog" width="730px" :show-close='false'>
      <el-row class="orgUserGroupChoice" v-if="!showrole">
        <el-col :span="12" class="flowLeft">
          <div class="flowTitle"><span class="active">人员选择</span></div>
          <div class="flowBody">
              <div class="searchStyle">
                <el-input
                  placeholder="请输入内容"
                  prefix-icon="el-icon-search"
                  class="header-search"
                  size="small"
                  :clearable='true'
                  v-model="inputOrganization"
                  @clear="breadcrumbUp(0,0,0)"
                  @keyup.enter="organizationSearch">
                </el-input>
                <el-button type="text" @click="organizationSearch" size="small">搜索</el-button>
                <!-- <el-button type="text" size="small" style="color:#FF2B45" @click="breadcrumbUp(0,0,0)">清空</el-button> -->
              </div>
              <div class="flowBodyList" v-loading="loading" element-loading-text="数据加载中">
                <el-scrollbar style="height:471px;">
                  <template v-if="flows.length==0">
                    <p style="text-align: center;margin-top: 25px;">暂无数据</p>
                  </template>
                  <template v-else>
                    <el-checkbox-group v-model="checkedFlow" @change="handleCheckedFlow">
                      <el-checkbox v-for="flow in flows" :key="flow.userId" :label="flow.userId">{{flow.realname}}</el-checkbox>
                    </el-checkbox-group>
                  </template>
                </el-scrollbar>
              </div>
            <div class="flowFoot">
              <el-checkbox v-if="flows.length>0" :indeterminate="flowIndeterminate" v-model="flowCheckAll" @change="handleCheckAllFlow" :disabled="radio_">全选组</el-checkbox>
            </div>
          </div>
        </el-col>
        <el-col :span="12" class="flowRight">
        <div class="flowTitle"><p>已选择<font style="color:#4e86ff">({{checkedFlow.length}})</font><el-button type="text" style="float:right;color:#FF2B45" @click="handleEmpty">清空</el-button></p></div>
          <div class="flowBody">
            <div class="flowInfoList">
              <el-tag type="info" :key="tag.userId" v-for="tag in checkedFlowArr" closable :disable-transitions="false" @close="handleCloseFlow(tag)" style="margin:10px 5px"> {{tag.realname}} </el-tag>
            </div>
            <div class="flowFoot">
              <el-button size='medium' type="primary" @click="submit(0)">确定</el-button>
              <el-button size='medium' @click="closeLevelSelect">取消</el-button>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-dialog>
  </el-row>
</template>

<script>
import { axiosBase } from '../../../api/api';
export default {
  name: 'orgUserGroupChoice',
  data () {
    return {
      dialogMultipleChoiceVisible:false,
      showrole:false,
      loading:false,
      radio_:false,
      checkboxDisabled:false,//配合radio使用
      //组织架构的参数
      inputOrganization:'',//组织架构搜索
      flowCheckAll: false,
      checkedFlowArr: [],
      checkedFlow: [],
      flows: [],
      breadcrumbdata:[{organizationId:0,name:'角色'}],
      flowIndeterminate: true,
      checkedList:[],
      parenId:'',
      muserArr:[],
      isAdmin: false
    }
  },
  methods: {
    orgGroupNameChoiceMethod(parenObj, isAdmin=false){
      this.isAdmin = isAdmin
      // isAdmin 用来判断是否是设置管理员 默认是设置主管
      this.dialogMultipleChoiceVisible = true;
      console.log("parenObj888--"+JSON.stringify(parenObj));
      this.breadcrumbdata=[{organizationId:0,name:'角色'}];
      this.flows=[];
      this.checkedFlowArr= [];
      this.checkedFlow= [];
      this.showrole_(parenObj.organizationId);
      this.parenId = parenObj.organizationId;
      this.flowCheckAll=false;
      // 主管
      if(!isAdmin&&parenObj.muser&&parenObj.muser.length>0){
        parenObj.muser.forEach((el)=>{
          this.checkedFlow.push(el.userId);
          var el1 = {};
          el1.realname = el.name || el.realname;
          el1.userId = el.userId;
          this.checkedFlowArr.push(el1);
        })
      }
      // 组织管理员
      if(isAdmin&&parenObj.admintor&&parenObj.admintor.length>0){

        parenObj.admintor.forEach((el)=>{
          this.checkedFlow.push(el.userId);
          var el1 = {};
          el1.realname = el.name || el.realname;
          el1.userId = el.userId;
          this.checkedFlowArr.push(el1);
        })
      }
    },
    showrole_(parenId){
      this.loading=true;
      if(this.flows.length<1&&this.breadcrumbdata.length<2){
        axiosBase({organizationId:parenId, curpage: 0, pagesize: 0},"/api/getuserlist").then(res => {
          console.log('pid:'+JSON.stringify(res))
          this.flows = res.data;
          this.loading=false;
        });
      }
    },
    organizationSearch(){
      if(this.inputOrganization==''){
        this.breadcrumbUp(0,0,0)
        return;
      }
      this.loading=true;
      this.breadcrumbdata = [{organizationId:0,name:'角色'}];
      axiosBase({realname: this.inputOrganization, organizationId:this.parenId,curpage: 0, pagesize: 0},"/api/getuserlist").then(res => {
        this.flows = res.data;
        this.loading=false;
      });

    },
    handleCheckAllFlow(val) {//角色全选
      if(!val){
        this.flows.forEach(element => {
          this.checkedFlow.forEach((ell,key) => {
            if(element.userId==ell){
             this.checkedFlow.splice(key,1);
             this.checkedFlowArr.splice(key,1);
            }
          })
        });
      }else{
        this.flows.forEach(el => {
          if(this.checkedFlow.indexOf(el.userId)===-1){
            this.checkedFlow.push(el.userId);
            this.checkedFlowArr.push(el);
          }
        });
      }
      this.flowIndeterminate = false;
    },
    handleEmpty(){//清空
      this.checkedFlowArr= [];
      this.checkedFlow= [];
      this.flowIndeterminate = false;
    },
    handleCheckedFlow(value) {//角色的选择
      var arrLen = this.checkedFlowArr.length;
      var valLen = value.length;
      if(arrLen<valLen){//原数据小于当前项就是新增，新增数据都是最后一条
        for(var i = 0;i<this.flows.length;i++){
          if(this.flows[i].userId==value[valLen-1]){
            this.checkedFlowArr.push(this.flows[i])
          }
        }
      }else{
        for(var j = 0; j<this.checkedFlowArr.length; j++){
          if(value.indexOf(this.checkedFlowArr[j].userId)===-1){
            this.checkedFlowArr.splice(j, 1);
          }
        }
      }
    },

    handleCloseFlow(tag) {//组织架构的tag删除
        this.checkedFlow.splice(this.checkedFlow.indexOf(tag.userId), 1);
        this.checkedFlowArr.splice(this.checkedFlowArr.indexOf(tag), 1);
      },
    closeLevelSelect(){
      this.dialogMultipleChoiceVisible = false;
       //第一个参数名为调用的方法名，第二个参数为需要传递的参数
    },
    submit(key){
      let arrList={key:key};
      if(this.checkedFlowArr.length>0){
        arrList.checkedFlow=this.checkedFlow;
        arrList.checkedFlowArr=this.checkedFlowArr;
      }
      console.log('arrlist'+JSON.stringify(arrList))
      this.$emit('orgUserGroupNameMethod',{arrList, isAdmin:this.isAdmin});
      this.dialogMultipleChoiceVisible = false;
      console.log("formName1-------"+JSON.stringify(arrList));
    },
    breadcrumbUp(item,key,style){//组织架构的面包屑style:0=清空
      if((this.breadcrumbdata.length)-1==key&&style!=0){
        return;
      }
      this.loading=true;
      this.inputOrganization="";
      axiosBase({organizationId:this.parenId, curpage: 0, pagesize: 0},"/api/getuserlist").then(res => {
          var leg = (this.breadcrumbdata.length)-key;
          if(key==0){
            this.breadcrumbdata = [{userId:0,name:'角色'}]
          }else{
            this.breadcrumbdata.splice(key+1,leg)
          }
          this.flows = res.data;
        });
      this.loading=false
    },
  },
  watch:{
    checkedFlow(){
      if(!this.radio_||this.checkedFlow.length<1){
        this.checkboxDisabled=false;
      }else{
        this.checkboxDisabled=true;
      }
    },
    inputOrganization(el){
      if(el==''){
        this.breadcrumbUp(0,0,0);
      }
    },
    dialogMultipleChoiceVisible(){
      this.inputOrganization = '';
    }
  },
	mounted() {

	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>
<style lang="scss" scoped>

  .flowLeft{border-right:1px solid #e5e5e5}
  .flowTitle{height:48px;line-height:48px;background:#fafafa;border-bottom: 1px solid #e5e5e5;padding:0;color:#999}
  .flowBody{height:540px;position: relative;}
  .searchStyle{padding:10px 10px 0}
  .header-search{width:76%;}
  .el-breadcrumb__link{padding:10px;}

  .flowBodyList{position: relative;}
  .flowInfoList{overflow: auto;height:470px;}
  .flowTitle p{padding:0 10px}
  .flowTitle span{cursor: pointer;background:#eee;display:inline-block;width:100px;text-align:center}
  // .flowTitle span.active{color:$base-text-unselected-color;background:#fafafa;}
  .flowFoot{border-top:1px solid #e5e5e5;padding:12px 5%;position: absolute;bottom:0;left:0;width:90%;z-index: 20;background:#fafafa;}
  .flowRight .flowFoot{padding:17px 5%;text-align:center;}
  .el-checkbox-group .el-checkbox{display:block;margin:10px 0px 10px 0;padding:6px 10px;color: #333}
  .el-checkbox-group .el-checkbox:nth-child(odd){background:#FBFBFB}
  .nentflows{width: 16%;overflow: hidden;padding:0 4%;text-align:right;position: absolute;top:0;right: 14px;}
  .nentflows .el-button{margin:0 0 10px; background:#fff;height:31px;border:none;}
  .nentflows .el-button:nth-child(odd){background:#FBFBFB}
  .loadMore{text-align:center;padding:4px;border-top:1px solid #eee;background:#f9f9f9;cursor: pointer;}
  .orgname{color: #666;background: #F4F3F3;font-size: 90%;padding: 2px 4px 0;margin:0 3px;border-radius: 2px;max-width: 90px;display: inline-block;vertical-align: middle}
</style>
